import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface CheckCircleFilledProps extends IconProps {
  color?: TIconColor;
}

// A confirmed CoP match, not a warning - single-tone (fill="currentColor" via iconColor)
// filled ring with the checkmark cut from the same path, per Figma. Defaults to
// 'green' (text-emerge-teal, #11E8C2) to match the design exactly.
const CheckCircleFilled = ({
  size,
  variant,
  className,
  color = 'green'
}: CheckCircleFilledProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM10.4069 6.79062C10.5674 6.56591 10.5153 6.25364 10.2906 6.09313C10.0659 5.93263 9.75364 5.98467 9.59313 6.20938L7.4362 9.22909L6.35355 8.14645C6.15829 7.95118 5.84171 7.95118 5.64645 8.14645C5.45118 8.34171 5.45118 8.65829 5.64645 8.85355L7.14645 10.3536C7.25037 10.4575 7.39476 10.5104 7.54124 10.4983C7.68772 10.4862 7.82144 10.4102 7.90687 10.2906L10.4069 6.79062Z"
      fill="currentColor"
    />
  </svg>
);

export default CheckCircleFilled;
